<template>
  <v-snackbar class="snackbar" v-model="$store.state.config.snackbar.open" :color="$store.state.config.snackbar.color" top>
    <div class="d-flex">
      <div class="mt-1">
        {{ $store.state.config.snackbar.text }}
      </div>
      <v-spacer></v-spacer>
      <v-btn color="white pa-2 me-0" fab text x-small @click="closeSnackbar()">
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </div>
  </v-snackbar>
</template>

<script>
export default {
  methods: {
    closeSnackbar() {
      let payload = {
        open: false,
        text: null,
        color: null,
      };
      this.$store.commit('SET_SNACKBAR', payload);
    },
  },
};
</script>

<style lang="scss">
.v-snack__content {
  font-size: 1.5rem !important;
  font-weight: 500;
}
</style>